export var TwilioErrorCode;
(function (TwilioErrorCode) {
    TwilioErrorCode[TwilioErrorCode["UNKNOWN"] = 1] = "UNKNOWN";
    TwilioErrorCode[TwilioErrorCode["INVALID_PHONE_NUMBER_FORMAT"] = 13223] = "INVALID_PHONE_NUMBER_FORMAT";
    TwilioErrorCode[TwilioErrorCode["INVALID_PHONE_NUMBER"] = 13224] = "INVALID_PHONE_NUMBER";
    TwilioErrorCode[TwilioErrorCode["FORBIDDEN_PHONE_NUMBER"] = 13225] = "FORBIDDEN_PHONE_NUMBER";
    TwilioErrorCode[TwilioErrorCode["INVALID_COUNTRY_CODE"] = 13226] = "INVALID_COUNTRY_CODE";
    TwilioErrorCode[TwilioErrorCode["NO_INTERNATIONAL_AUTHORIZATION"] = 13227] = "NO_INTERNATIONAL_AUTHORIZATION";
    TwilioErrorCode[TwilioErrorCode["TIMEOUT"] = 31000] = "TIMEOUT";
    TwilioErrorCode[TwilioErrorCode["ICE_ERROR"] = 31003] = "ICE_ERROR";
    TwilioErrorCode[TwilioErrorCode["TOKEN_EXPIRED"] = 31205] = "TOKEN_EXPIRED";
    TwilioErrorCode[TwilioErrorCode["NO_MICROPHONE_ACCESS"] = 31208] = "NO_MICROPHONE_ACCESS";
})(TwilioErrorCode || (TwilioErrorCode = {}));
export var CallConnectionStatusEnum;
(function (CallConnectionStatusEnum) {
    CallConnectionStatusEnum[CallConnectionStatusEnum["CLOSED"] = 0] = "CLOSED";
    CallConnectionStatusEnum[CallConnectionStatusEnum["PENDING"] = 1] = "PENDING";
    CallConnectionStatusEnum[CallConnectionStatusEnum["CONNECTING"] = 2] = "CONNECTING";
    CallConnectionStatusEnum[CallConnectionStatusEnum["OPEN"] = 3] = "OPEN";
})(CallConnectionStatusEnum || (CallConnectionStatusEnum = {}));
export var CallParticipantStatus;
(function (CallParticipantStatus) {
    CallParticipantStatus[CallParticipantStatus["CONNECTING"] = 10] = "CONNECTING";
    CallParticipantStatus[CallParticipantStatus["TALKING"] = 20] = "TALKING";
    CallParticipantStatus[CallParticipantStatus["ON_HOLD"] = 30] = "ON_HOLD";
    CallParticipantStatus[CallParticipantStatus["MUTED"] = 40] = "MUTED";
    CallParticipantStatus[CallParticipantStatus["LEFT"] = 50] = "LEFT";
    CallParticipantStatus[CallParticipantStatus["DECLINED"] = 60] = "DECLINED";
    CallParticipantStatus[CallParticipantStatus["NO_ANSWER"] = 70] = "NO_ANSWER";
    CallParticipantStatus[CallParticipantStatus["CANCELLED"] = 80] = "CANCELLED";
    CallParticipantStatus[CallParticipantStatus["INVITED"] = 90] = "INVITED";
})(CallParticipantStatus || (CallParticipantStatus = {}));
//# sourceMappingURL=twilio.js.map